import { useQuery } from '@tanstack/react-query'
import { realOrdersApi } from '../api/ordersApiReal'
import type { OrdersParams } from '../types/orders.types'
import { useTenantStore } from '../../../shared/stores/useTenantStore'

export const useOrders = (params?: OrdersParams) => {
  const activeMerchantId = useTenantStore((s) => s.activeMerchant?.id)

  return useQuery({
    queryKey: ['orders', params, activeMerchantId],
    queryFn: () => realOrdersApi.getOrders(params),
    enabled: !!activeMerchantId,
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  })
}

// Simplified hook that returns orders array and loading/error states
export const useOrdersData = (params?: OrdersParams) => {
  const { data, isLoading, error, refetch } = useOrders(params)
  
  return {
    orders: data?.orders || [],
    meta: data?.meta || null,
    isLoading,
    error,
    refetch
  }
}